import React, { useEffect, useState } from 'react';
import mixpanel from 'mixpanel-browser';
import { useAuth0 } from '@auth0/auth0-react';

export default function LoginHelper() {
  const { loginWithRedirect } = useAuth0();

  useEffect(() => {
    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);
    const connectorInviteId = urlParams.get('connector-invite-id');
    if (connectorInviteId) {
      mixpanel.track('Click Invite Link', { ConnectorID: connectorInviteId });
    }
  }, []);

  useEffect(() => {
    loginWithRedirect({
      redirectUri: window.location.href
    });
  }, [loginWithRedirect]);

  return (<></>);
}
